import { useState } from 'react';
import { apiError } from '../../../../lib/host';
import { useT } from '../../../../lib/i18n';
import { usePreferences } from '../../preferences/PreferencesContext';
import { useBasic } from '../../ui';

/** For sections that apply each choice at once (Appearance, Accessibility): save it, confirm, or show why not. */
export default function useAutoSave(section) {
  const { t } = useT();
  const { prefs, save } = usePreferences();
  const { notify } = useBasic();
  const [error, setError] = useState('');
  const set = (values) => {
    setError('');
    save(section, values).then(() => notify(t('Saved. Your dashboard is updated.'))).catch((err) => setError(apiError(err)));
  };
  return { values: prefs[section], set, error };
}
